/*
 * @Author: 张天昊
 * @Date: 2024-07-08 16:58:39
 * @LastEditTime: 2024-07-08 17:00:03
 * @LastEditors: 张天昊
 * @Description: 
 * @FilePath: /Mobile/src/utils/blob2string.js
 */
export async function blob2string(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(blob, 'utf-8');
    reader.onload = function (e) {
      resolve(reader.result)
    }
    reader.onerror = function (error) {
      reject(error)
    }
  })
}
